import { SectionHeader, SwitchAppButton } from "../../../components";
import { IOnboardingStep5ViewProps } from "./OnboardingStep5";

import { PaymentMethod } from "../../PaymentMethod";

export const View = ({
  isActive,
  handlePrevious,
  handleNext,
}: IOnboardingStep5ViewProps) => {
  return (
    <div className="onboarding-section">
      <SectionHeader
        title="Configure payment providers."
        subtitle="Configure the payments methods and providers which yours customers can use to make payments."
      />

      <PaymentMethod hideActivationRequired />

      <div className="flex-container buttons-container">
        {!isActive ? null : (
          <SwitchAppButton
            className="switchapp-themed onboarding-previous--button"
            kind="secondary"
            onClick={handlePrevious}
          >
            Previous
          </SwitchAppButton>
        )}

        {!isActive ? null : (
          <SwitchAppButton
            onClick={handleNext}
            className="switchapp-themed onboarding-submit--button"
          >
            Continue
          </SwitchAppButton>
        )}
      </div>
    </div>
  );
};
